import Vue from "vue"
import Buefy from "buefy"

import ActivateEmailNotify from "./App.vue"

Vue.use(Buefy, {
    defaultIconPack: 'fas',
})
Vue.use(ActivateEmailNotify)

if(document.getElementById("activateEmailNotifyApp")){
    new Vue({
        render: h=>h(
            ActivateEmailNotify,{
                props:{
                    username:document.getElementById("activateEmailNotifyApp")
                        .getAttribute("username"),
                    resendValidation:document.getElementById("activateEmailNotifyApp")
                        .getAttribute("resend-validation")
                }
            }
        )
    }).$mount("#activateEmailNotifyApp")
}